/***
 * @description It will dispatch a custom event to Unified Header component, and it will reload Unified Header data.
 * */
export function reloadUnifiedHeaderData() {
  const event = new CustomEvent('reloadUnifiedHeader');
  document.dispatchEvent(event);
}
